import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { UpgradeBottomSlides } from 'ThreeTerminal_mobile_dynamic';

class BottomSlides extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const { content } = this.props;
        const url = typeof location === 'undefined' ? '' : location.href;
        const slidesConfig = {
            apiConfig: {
                type: 'doc',
                from: 'wap_relate_foot_doc',
                n: '4',
                // proid: 'ifeng_wap',
                id: `ucms_${content.base62Id}`,
                // title: content.title,
                apiUrl: 'nine',
            },
            isLogoPic: true,
            insertSlideArr: [
                {
                    kind: 'df_sf01',
                    downloads: {
                        download: 'https://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK1429035767411',
                        downloadAd: 'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=7675',
                    },
                    clickCount: {
                        behavior: 'action',
                        type: 'downopen',
                        other: {
                            ref: `ucms_${content.base62Id}`,
                            to: true,
                            kind: 'article',
                            url: encodeURIComponent(url),
                            plat: 'napp',
                            downurl: encodeURIComponent(
                                'http://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK1348580715362',
                            ),
                        },
                    },
                },
                {
                    kind: 'df_sf01',
                    downloads: {
                        download: 'https://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK1429035767411',
                        downloadAd: 'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=7675',
                    },
                    clickCount: {
                        behavior: 'action',
                        type: 'downopen',
                        other: {
                            ref: `ucms_${content.base62Id}`,
                            kind: 'article',
                            url: encodeURIComponent(url),
                            plat: 'napp',
                            downurl: encodeURIComponent(
                                'http://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK1348580715362',
                            ),
                        },
                    },
                },
                {
                    kind: 'df_sf01',
                    downloads: {
                        download: 'https://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK1429035767411',
                        downloadAd: 'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=7675',
                    },
                    clickCount: {
                        behavior: 'action',
                        type: 'downopen',
                        other: {
                            ref: `ucms_${content.base62Id}`,
                            kind: 'article',
                            url: encodeURIComponent(url),
                            plat: 'napp',
                            downurl: encodeURIComponent(
                                'http://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK1348580715362',
                            ),
                        },
                    },
                },
            ],
            // lastSlideData: {
            //     type: 'web',
            //     thumbnailpic: 'https://x0.ifengimg.com/fe/custom/2023_10_08/mbanner2.c096985ebdca.png',
            //     linkUrl: 'https://ishare.ifeng.com/loc/webdaoliu/index',
            //     isDoliu: true,
            // },
        };

        return (
            <div className={styles.bottom_box}>
                <UpgradeBottomSlides content={slidesConfig} />
            </div>
        );
    }
}

export default errorBoundary(BottomSlides);
